import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService {

  constructor(
    private http: HttpClient
  ) { }

  getGeneratedSchedules(termId): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + `api/v1/admin/scheduling/${termId}/list`, { withCredentials: true });
  }

  generateSchedule(item: any, schoolYearTerm_id: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + `api/v1/admin/scheduling/generate/${schoolYearTerm_id}`, JSON.stringify(item), { withCredentials: true });
  }

  getGeneratedScheduleProgress(process_id: any): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + `api/v1/admin/scheduling/progress/${process_id}`, { withCredentials: true });
  }

  getGeneratedScheduleDetails(schedule_id: any): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + `api/v1/admin/scheduling/${schedule_id}/details`, { withCredentials: true });
  }

  getScheduleAvailable(schedule_id: any, student_id): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + `api/v1/admin/scheduling/${schedule_id}/student/${student_id}/available`, { withCredentials: true });
  }

  generateStudentSchedules(student_id: any, item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + `api/v1/admin/scheduling/${student_id}/generate`, JSON.stringify(item),{ withCredentials: true });
  }

  finalizeSchedule(sched_id: any): Observable<any> {
    return this.http
      .patch<any>(environment.apiUrl + `api/v1/admin/scheduling/${sched_id}/finalize`, '',{ withCredentials: true });
  }

  getSchedulesUnmatched(schedule_id: any): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + `api/v1/admin/scheduling/${schedule_id}/unmatched`, { withCredentials: true });
  }

  createScheduleDetails(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + `api/v1/admin/scheduling/add`, JSON.stringify(item),{ withCredentials: true });
  }

  updateScheduleDetails(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + `api/v1/admin/scheduling/update`, JSON.stringify(item),{ withCredentials: true });
  }
}
